import SearchEscalator from './SearchEscalator'

export default SearchEscalator